import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ITimeline, ITimelineDefinition } from '@lib/timeline';

@Injectable({ providedIn: 'root' })
export class TimelineService {
  public eventURL = 'https://14sw4h5s90.execute-api.us-east-1.amazonaws.com/dev/';

  constructor(private readonly _httpClient: HttpClient) {}

  public getTimelineData(url: string): Observable<ITimelineDefinition[]> {
    return this._httpClient.get<ITimelineDefinition[]>(url);
  }

  public export(url: string): Observable<any> {
    return this._httpClient.get(url, {
      responseType: 'blob',
      reportProgress: true,
      observe: 'events',
    });
  }

  public addToVault(
    cameraId: string,
    start: number,
    end: number,
    vaultIncidents?: any,
    notifyByText?: any,
    notifyByEmail?: any,
  ): Observable<any> {
    return this._httpClient.post(`/api/cameras/${cameraId}/recordings/`, {
      start,
      end,
      vaultIncidents,
      notifyByText,
      notifyByEmail,
    });
  }

  public getAIData(id: string, params?: any): Observable<any> {
    return this._httpClient
      .get(`${this.eventURL}events/${id}`, { params })
      .pipe(map((response: any) => response.results));
  }

  public getCarColors(): Observable<any> {
    return this._httpClient
      .get(`${this.eventURL}settings/colors`)
      .pipe(map((response: any) => response.results));
  }

  public getTimelinePath(timeline: ITimeline[], startTime: number): any {
    const reversedTimeline = timeline.reverse();
    const formattedStartTime = startTime / 1000;
    let i = 0;
    while (i < reversedTimeline.length) {
      const start = reversedTimeline[i].start;
      const end = reversedTimeline[i].end;
      if (start < formattedStartTime && formattedStartTime < end) {
        return reversedTimeline[i];
      }
      i++;
    }
  }
}
